// chevron icons replaced with inline SVGs for consistent iOS rendering
import "./sidebar.css";

function MenuList({ className = "", toggle, onLogout }) {

  return (
    <></>
  );
}

export default MenuList;
